import {reactive} from 'vue';

let activeStore = null;

export const createChatStore = () => {
  activeStore = reactive({
    webPushConfirmed: false,
    list: {
      selectedCategoryKey: null,
      categoryStates: {},
      updateCursor: null,
    },
    details: {},
  });

  return activeStore;
};

export const getChatDetailState = (store, publicCustomerId) => {
  const key = String(publicCustomerId);
  if (store.details[key] === undefined) {
    store.details[key] = {
      nickname: '',
      displayName: null,
      icon_path: '',
      partner_last_read_message_id: null,
      chatRate: 1,
      freeChatEnabledFlg: false,
      freeChatCount: 0,
      freeChatUsedCount: 0,
      freeChatAvailableFlg: false,
      saioshiFlg: false,
      blockedFlg: false,
      talkTheme: null,
      moderationEnabled: true,
      moderationPromptChecked: false,
      messages: [],
      reactionUpdates: {},
      nextCursor: null,
      hasNext: false,
      hasUnread: false,
      isLoaded: false,
      isLoading: false,
      hasError: false,
      readAttempted: false,
      draft: '',
      scrollTop: null,
      scrollReset: false,
      updateCursor: null,
    };
  }

  return store.details[key];
};

export const resetChatDetailScroll = (publicCustomerId) => {
  const state = activeStore?.details[String(publicCustomerId)];
  if (state === undefined) {
    return;
  }

  state.scrollTop = null;
  state.scrollReset = true;
};
